import { ElementType } from "react";
import DashboardIcon from "../assets/icons/sidebar/DashboardIcon";
import InvoiceIcon from "../assets/icons/sidebar/InvoiceIcon";
import VendorsIcon from "../assets/icons/sidebar/VendorsIcon";
import { TUserRoles, USER_ROLES } from "../types/global.type";

interface MenuType {
  name: string;
  path: string;
  icon?: ElementType;
  badge?: string;
  role: TUserRoles[];
}

interface MenuTypes extends MenuType {
  children?: MenuType[];
}

const AllSidebarMenu: MenuTypes[] = [
  // ------ Routes for ADMIN & SUPER-ADMIN ------
  {
    name: "Dashboard",
    path: "/admin/dashboard",
    icon: DashboardIcon,
    role: [USER_ROLES.ADMIN],
  },
  {
    name: "Vendors",
    path: "/admin/vendors",
    icon: VendorsIcon,
    role: [USER_ROLES.ADMIN],
  },
  {
    name: "Invoice",
    path: "/admin/invoices",
    icon: InvoiceIcon,
    role: [USER_ROLES.ADMIN],
    children: [
      {
        name: "Invoices",
        path: "/admin/invoices/list",
        role: [USER_ROLES.ADMIN],
      },
      {
        name: "Waiting for approval",
        path: "/admin/invoices/waiting-for-approval",
        role: [USER_ROLES.ADMIN],
      },
      {
        name: "Waiting for payment",
        path: "/admin/invoices/waiting-for-payment",
        role: [USER_ROLES.ADMIN],
      },
      {
        name: "Payments",
        path: "/admin/invoices/payments",
        role: [USER_ROLES.ADMIN],
      },
    ],
  },
];

export default AllSidebarMenu;
